export default __webpack_public_path__ + "static/media/banner_img.9dcea57d.png";